export class RuntimeIssue {
}
export var WorkflowIssueTypeEnum;
(function (WorkflowIssueTypeEnum) {
    WorkflowIssueTypeEnum["MISSING_VALUE"] = "MISSING_VALUE";
    WorkflowIssueTypeEnum["MAX_LENGTH_ACCESSED"] = "MAX_LENGTH_ACCESSED";
    WorkflowIssueTypeEnum["WORKFLOW_ID_ALREADY_EXISTS"] = "WORKFLOW_ID_ALREADY_EXISTS";
    WorkflowIssueTypeEnum["DUPLICATED_VALUE"] = "DUPLICATED_VALUE";
    WorkflowIssueTypeEnum["LIMIT_REACHED"] = "LIMIT_REACHED";
})(WorkflowIssueTypeEnum || (WorkflowIssueTypeEnum = {}));
